import { createRouter, createWebHistory } from 'vue-router';
import LoginRoutes from '@/app/modules/login/login.routes';
import HomeRoutes from '@/app/modules/home/home.routes';
import EventsRoutes from '@/app/modules/events/events.routes';
import { ReportsRoutes } from '@/app/modules/reports/reports.routes.js';
import UsersRoutes from '@/app/modules/users/users.routes';
import SettingsRoutes from '@/app/modules/settings/settings.routes';
import SeatingRoutes from '@/app/modules/seating/seating.routes';
import { BookingsRoutes } from '@/app/modules/bookings/bookings.routes';
import GuestListRoutes from '@/app/modules/guestList/guestList.routes';
import App403Page from '@/app/core/components/App403Page/App403Page.vue';
import App404Page from '@/app/core/components/App404Page/App404Page.vue';
import ClubsRoutes from '@/app/modules/clubs/clubs.routes';
import VenueModeRoutes from '@/app/modules/venueMode/venueMode.routes';

const ErrorsRoutes = [{ path: '/403', name: '403', component: App403Page }];

const fallbackRoute = {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: App404Page,
    meta: {
        needsAuthenticatedUser: false,
    },
};

const routes = [].concat(
    LoginRoutes,
    HomeRoutes,
    BookingsRoutes,
    EventsRoutes,
    GuestListRoutes,
    ReportsRoutes,
    UsersRoutes,
    SettingsRoutes,
    SeatingRoutes,
    ClubsRoutes,
    VenueModeRoutes,
    ErrorsRoutes,
    [fallbackRoute]
);

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
});

export default router;
